import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'prodsFilter'
})
export class ProdsFilterPipe implements PipeTransform {

  transform(value: any, start?: any, end?: any): any {

    // let newArray = value.filter(prod => prod.posComp <= args);

    //new
    let newArray = value.filter(function (prod:any) {


       let condition = !start ? prod.posComp < end + 1 : prod.posComp >= start && end + 1 >= prod.posComp
 
      if (condition) {
        return prod;
      }
    });
    return newArray;


  }

}
